<template>
    <div>
         <div :style="{ 'background-image': background_image }" class="banner">
            <div class="banner-text">{{bannerText}}
                <p class = "nameText">{{Quote}}<v-icon class = "material-icons-round">check_circle</v-icon></p>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'RhsBanner',
    props: {
        bannerMessage: {
            type: String
        },
        isLogin: Boolean,
        step: Number,
        showIntermediateStep: Boolean
    },
    computed: {
        bannerText () {
            if (this.isLogin) {
                return 'Welcome! Happy to see you back home.'
            } else if (this.showIntermediateStep && this.step < 6) {
                return 'We are excited to see you back here. Kudos on the progress you have made till now! Let us complete your wealth creation journey quickly!'
            } else {
                switch (this.step) {
                case 1: return 'We send only important updates and notifications. No spam. We value your time and money.'
                case 2: return 'IndiaP2P investments are regulated by the RBI. Your Aadhaar details are required for KYC compliance.'
                case 3: return 'Please enter your PAN and verify your name and DOB as fetched from your Aadhaar.'
                case 4: return 'We look forward to crediting your bank account regularly with predictable, purposeful returns.'
                case 5: return 'You can choose between the higher, compounding returns (Growth Plan) or regular earnings payouts (Income Plan)'
                case 6: return 'All your investments, repayments, and returns are transacted via an RBI-compliant escrow account.'
                case 7: return 'Congratulations on starting your wealth creation journey with us. Let us complete your registration with one last step.'
                default: return 'We are excited to welcome you to our growing IndiaP2P tribe. Please keep your Aadhaar, PAN and Bank details handy to complete our swift KYC process and start earning!'
                }
            }
        },
        background_image () {
            if (this.isLogin) {
                return 'url(img/NehaNew.webp)'
            } else if (this.showIntermediateStep && this.step < 7) {
                return 'url(img/MohitNew.webp)'
            } else {
                switch (this.step) {
                case 1: return 'url(img/RavinderNew.webp)'
                case 2: return 'url(img/VinayakNew.webp)'
                case 3: return 'url(img/NehaNew.webp)'
                case 4: return 'url(img/MohitNew.webp)'
                case 5: return 'url(img/RavinderNew.webp)'
                case 6: return 'url(img/VinayakNew.webp)'
                case 7: return 'url(img/NehaNew.webp)'
                default: return 'url(img/RavinderNew.webp)'
                }
            }
        },
        Quote () {
            if (this.isLogin) {
                return 'Neha'
            } else if (this.showIntermediateStep && this.step < 7) {
                return 'Mohit'
            } else {
                switch (this.step) {
                case 1: return 'Ravinder'
                case 2: return 'Vinayak'
                case 3: return 'Neha'
                case 4: return 'Mohit'
                case 5: return 'Ravinder'
                case 6: return 'Vinayak'
                case 7: return 'Neha'
                default: return 'Ravinder'
                }
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.nameText {
    padding-bottom: 90px;
    position: relative;
    text-align: left;
    font-size: 10px;
    font-weight: 600 !important;
    padding-top: 5px;
        @media (min-width: 992px) {
            padding-bottom: 90px;
            position: relative;
            text-align: left;
            font-size: 16px;
            font-weight: 600 !important;
            padding-top: 5px;
    }
}

::v-deep .v-icon.v-icon {
    padding-left: 4px;
    font-size: 12px;
    color: #002fa7;
    @media (min-width: 992px ) {
        padding-left: 4px;
        font-size: 18px;
        color: #002fa7;
    }
}

.banner {
    background-size: 250px;
    position: relative;
    background-position: center;
    width: 100% !important;
    min-height: 400px !important;

    @media (min-width: 992px) {
        position: relative;
        background-position: center;
        width: 550px !important;
        background-size: auto;
        height: 100% !important;
    }
    @media (min-width: 1200px) {
        position: relative;
        background-position: center;
        width: 550px !important;
        background-size: auto;
        height: 100% !important;
    }

    &--logo {
        width: 150px;
        display: block;
        margin-bottom: 15px;
        display: none;

        @media (min-width: 992px) {
            width: 200px;
            margin-bottom: 30px;
            display: block;
        }
    }

    .banner-text {
        top: 62%;
        position: absolute;
        font-size: 12px;
        color: #000000;
        text-align: left;
        left: 51%;
        transform: translate(-50%, -50%);
        width: 200px;

        @media (min-width: 992px) {
            width: 380px;
            top: 53%;
            left: 53%;
            transform: translate(-50%, -50%);
            position: absolute;
            font-size: 18px;
            text-align: left;
        }
    }
}

</style>
